export const SELLER_CODE_MAX_LENGTH = 50;

const SELLER_CODE_PATTERN = /^[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/;

export const sanitizeSellerCode = (value: string): string =>
	String(value ?? "")
		.replace(/[^A-Za-z0-9-]/g, "")
		.replace(/^-+/, "")
		.slice(0, SELLER_CODE_MAX_LENGTH);

/**
 * El código está completo y bien formado, es decir: se puede mandar a verificar.
 */
export const isValidSellerCodeFormat = (value: string): boolean => {
	const code = String(value ?? "").trim();
	return (
		code.length > 0 &&
		code.length <= SELLER_CODE_MAX_LENGTH &&
		SELLER_CODE_PATTERN.test(code)
	);
};
